import React from 'react';
import CheckIcon from '@mui/icons-material/Check';
import styles from './WizardProgress.module.css';

/** Trilha das etapas: concluídas com check, atual destacada. */
function WizardProgress({ steps, current }) {
  return (
    <ol className={styles.progress} aria-label="Etapas da configuração">
      {steps.map((step, index) => {
        const state = index < current ? styles.done : index === current ? styles.current : '';
        return (
          <li key={step.key} className={`${styles.step} ${state}`} aria-current={index === current ? 'step' : undefined}>
            <span className={styles.label}>
              {index < current && <CheckIcon className={styles.check} fontSize="inherit" />}
              {step.label}
            </span>
          </li>
        );
      })}
    </ol>
  );
}

export default WizardProgress;
